{{companyName != '' ? companyName : 'Brak nazwy'}}